import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "utils/context";

import { INVENTORY_INCREASE_STATUS } from "./services/data.transformers";
import { useSelector } from "react-redux";

import Amount from "./components/pages/amount";
import Prepayment from "./components/pages/payment";
import PaymentMethod from "./components/pages/method";
import Receipt from "./components/pages/receipt";

import PageLayout from "./components/layout/layout";

import { pmaPayment, pmaSubmitReceipt } from "./services/service";

import "./index.scss";

const PMAOnboarding = () => {
  const { instance } = useAppContext();
  const userPma = useSelector((state) => state?.pmaReducer?.userPma);

  const navigate = useNavigate();
  const [amount, setAmount] = useState(null);
  const [loading, setLoading] = useState(false);
  const [receiptData, setReceiptData] = useState(false);
  const [bankAccounts, setBankAccounts] = useState(false);

  const [currentStage, setCurrentStage] = useState(
    INVENTORY_INCREASE_STATUS.AMOUNT
  );
  const [data, setData] = useState(null);

  const handleSubmitAmount = async (value) => {
    setLoading(true);

    const response = await pmaPayment(instance, {
      prx: userPma?.prx,
      amount: Number(value?.amount?.replaceAll(",", "")),
    });
    if (response) {
      setAmount(value?.amount);
      setData(response);
      setCurrentStage(INVENTORY_INCREASE_STATUS.PAYMENT);
    }

    setLoading(false);
  };

  const handleFinishPaymentMethod = async () => {
    setLoading(true);
    const { data: submitReceiptData } = await pmaSubmitReceipt(
      instance,
      data?.uuid
    );
    if (submitReceiptData) {
      setReceiptData(submitReceiptData);
      setCurrentStage(INVENTORY_INCREASE_STATUS.RECEIPT);
    }
    setLoading(false);
  };

  const handlePaymentReq = () => {
    setCurrentStage(INVENTORY_INCREASE_STATUS.METHOD);
  };

  const handleSetBanksData = (bankData) => setBankAccounts(bankData);

  const onBack = () => {
    switch (currentStage) {
      case INVENTORY_INCREASE_STATUS.PAYMENT:
        return setCurrentStage(INVENTORY_INCREASE_STATUS.AMOUNT);

      case INVENTORY_INCREASE_STATUS.METHOD:
        return setCurrentStage(INVENTORY_INCREASE_STATUS.PAYMENT);

      case INVENTORY_INCREASE_STATUS.RECEIPT:
        return setCurrentStage(INVENTORY_INCREASE_STATUS.METHOD);

      case INVENTORY_INCREASE_STATUS.AMOUNT:
      default:
        return navigate(-1);
    }
  };

  const onClose = () => {
    navigate(-1);
  };

  const renderPMAStage = () => {
    switch (currentStage) {
      case INVENTORY_INCREASE_STATUS.AMOUNT:
        return (
          <Amount
            amount={amount}
            loading={loading}
            onFinish={handleSubmitAmount}
          />
        );

      case INVENTORY_INCREASE_STATUS.PAYMENT:
        return (
          <Prepayment
            amount={amount}
            data={data}
            onPaymentReq={handlePaymentReq}
            onSetBanksData={handleSetBanksData}
          />
        );

      case INVENTORY_INCREASE_STATUS.METHOD:
        return (
          <PaymentMethod
            amount={amount}
            bankAccounts={bankAccounts}
            loading={loading}
            trxUuid={data?.uuid}
            onFinish={handleFinishPaymentMethod}
          />
        );

      case INVENTORY_INCREASE_STATUS.RECEIPT:
        return (
          <Receipt
            amount={amount}
            receiptData={receiptData}
            onClose={onClose}
          />
        );

      default:
        return "";
    }
  };

  return (
    <PageLayout currentStage={currentStage} onBack={onBack} onClose={onClose}>
      {renderPMAStage()}
    </PageLayout>
  );
};
export default PMAOnboarding;
